import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  message: null,
};

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    onLoading: (state) => {
      state.isLoading = true;
      state.message = null;
    },
    onErrorMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    onSuccessMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "success",
        text: payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { onLoading, onErrorMessage, onSuccessMessage } =
  adminSlice.actions;
